<template>
    <div class="connectionContainer">
        <div class="connectionHeader">
            <div class="modal_title"> 広告アカウント設定</div>
        </div>
        <div class="connectionContents">
            <div class="modal_body">
                <div class="modal_form">
                    <template v-if="!createMode">
                        <h3><span>【{{ this.account.id }}】</span>{{ this.account.name }}</h3>
                    </template>
                    <div class="modal_input">
                        <label>アカウント名</label>
                        <input type="text" placeholder="アカウント名" v-model="account.name">
                    </div>
                    <div class="modal_input">
                        <label>アカウントID</label>
                        <input type="text" placeholder="アカウントID" v-model="account.account_id">
                    </div>
                    <div class="modal_input">
                        <label>サービス名</label>
                        <select v-model="account.service_id">
                            <option value="" disabled>サービス名</option>
                            <option v-for="service in services" :value="service.id" v-bind:key="service.id">{{ service.name
                            }}</option>
                        </select>
                    </div>
                    <div class="modal_input">
                        <label>広告媒体名</label>
                        <select v-model="account.media_id">
                            <option value="" disabled>広告媒体名</option>
                            <option v-for="media in medias" :value="media.id" v-bind:key="media.id">{{ media.name
                            }}</option>
                        </select>
                    </div>
                    <div class="modal_input">
                        <label>備考</label>
                        <input type="text" placeholder="備考" v-model="account.memo">
                    </div>
                </div>
                <div class="modal_submit">
                    <template v-if="createMode">
                        <Button width="100px" @click="createAccount">追加</Button>
                    </template>
                    <template v-else>
                        <Button width="100px" @click="updateAccount">更新</Button>
                    </template>
                </div>
            </div>
        </div>
        <div class="connectionFooter">
            <template v-if="!createMode">
                <Button class="btn deleteBtn" @click="openDeleteModal">削除</Button>
            </template>
        </div>
        <modal name="deleteModal" :draggable="false" :resizable="false" width="60%" height="200px">
            <DeleteModal @canceled="closeDeleteModal" @deleted="deleteAccount"/>
        </modal>
    </div>
</template>

<script>
import DeleteModal from './DeleteModal.vue';
export default {
    props: {
        createMode: Boolean,
        accountId: Number,
    },
    components: {
        DeleteModal,
    },
    data() {
        return {
            account: {},
            services: {},
            medias: {}
        }
    },
    mounted: function () {
        //編集の場合、対象のアカウント情報取得
        if (this.accountId !== null) {
            this.getAccount();
        }

        //新規追加の場合
        else {
            //サービス名・広告媒体名の初期値セット
            this.account.service_id = "";
            this.account.media_id = "";
        }

        //サービス名・広告媒体名のプルダウンセット
        this.getServiceId();
        this.getMediaId();
    },
    methods: {
        //選択された広告アカウント取得
        getAccount: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/adAccount/" + this.accountId)
                .then((res) => {
                    this.account = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //サービスIDの一覧取得
        getServiceId: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/service/")
                .then((res) => {
                    this.services = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //広告媒体IDの一覧取得
        getMediaId: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/media/")
                .then((res) => {
                    this.medias = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },

        //追加
        createAccount: function () {
            this.$store.dispatch("loading", true);
            const data = {
                service_id: this.account.service_id,
                media_id: this.account.media_id,
                name: this.account.name,
                account_id: this.account.account_id,
                memo: this.account.memo
            };
            this.axios.post("/api/adAccount/", data)
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },


        //更新
        updateAccount: function () {
            this.$store.dispatch("loading", true);
            const data = {
                id: this.account.id,
                service_id: this.account.service_id,
                media_id: this.account.media_id,
                name: this.account.name,
                account_id: this.account.account_id,
                memo: this.account.memo
            };
            this.axios.put("/api/adAccount/" + this.accountId, data)
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },


        //削除
        deleteAccount: function () {
            this.$store.dispatch("loading", true);
            this.axios.delete("/api/adAccount/" + this.accountId)
                .then(() => {
                    this.modalClose();
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },


        //削除モーダル オープン・クローズ
        openDeleteModal() {
            this.$modal.show('deleteModal');
        },
        closeDeleteModal() {
            this.$modal.hide('deleteModal');
        },


        //データを再取得してこのモーダルを閉じる
        //親メソッド（AdAccount.vue）で実行
        modalClose() {
            this.$emit('modalClosed');
            this.$store.dispatch("successful", false);
        }
    }
}

</script>


<style scoped lang="sass">
.connectionContainer
    height: 100%
    width: 100%
    margin: 0
    padding: 10px
    display: inline-grid
    grid-template-rows: 40px 1fr 40px
    grid-row-gap: 10px
    .cancelBtn
        width: 100px
        background-color: #ccc
        border: 1px solid #ccc
    .deleteBtn
        width: 100px
        background-color: #ff5252
        border: 1px solid #ff5252
    .connectionHeader
        display: flex
        align-items: center
        font-size: 1.5rem
        justify-content: center
        .modal_title
            font-size: 1.8rem
    .connectionContents
        display: inline-grid
        overflow: auto
        .modal_form
            padding: 32px
            h3
                font-size: 1.6rem
                font-weight: 700
                margin-bottom: 24px
            p
                font-size: 1.4rem
                color: #777
            .modal_input
                margin-bottom: 24px
                display: flex
                justify-content: start
                align-items: center
                label
                    font-size: 1.4rem
                    width: 30%

                input
                    border: 1px solid $grayColor
                    width: 70%
                    padding: 10px
                    text-align: left
                    width: 100%
                    &:focus
                        outline: 2px solid $mainColor
                select
                    padding: 10px
                    width: 100%
        .modal_submit
            display: flex
            justify-content: center
    .modal_delete
        padding: 24px
        p
            font-size: 1.6rem
        .delete_btns
            margin-top: 40px
            display: flex
            justify-content: space-evenly
    .connectionFooter
        display: flex
        justify-content: start
</style>
